import { forwardRef, type SVGProps } from "react";
// eslint-disable-next-line react/display-name
const SvgHome = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <path
        d="M1.21484 11.5765L11.9765 0.814819L22.7383 11.5765"
        stroke="currentColor"
        strokeWidth="1.52778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5879 2.73651H20.047V6.57998"
        stroke="currentColor"
        strokeWidth="1.52778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5483 12.0186V21.1852H4.27051V12.0186"
        stroke="currentColor"
        strokeWidth="1.52778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.281 20.8776V12.7295H8.13281V20.8776"
        stroke="currentColor"
        strokeWidth="1.52778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
));
export default SvgHome;
